import { CSSObject } from '@chakra-ui/react';

export const FlexBannerWrapper: CSSObject = {
  px: '4',
  py: '2.5',
  m: 'auto',
  h: '12',
  w: 'container.xl',
};

export const FlexWrapper: CSSObject = {
  boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  bgGradient: 'linear(to-b, alpha.500, alpha.700)',
  bgSize: 'cover',
  borderBottom: '2px solid',
  borderColor: 'beta.400',
};

export const FlexItemsWrapper: CSSObject = {
  mr: '0',
  columnGap: '1',
  '& > div:last-of-type': { mr: '0' },
  minH: 'full',
};

export const CountdownTimer = {
  '&': {
    '.countdown-flex': {
      background: 'transparent',
    },
  },
};

export const LinkItem: CSSObject = {
  w: '40',
  h: 'full',
  py: '2px',
  borderRadius: 'base',
  bgGradient: 'linear(to-b, alpha.300, alpha.400)',
  color: 'white',
  boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.20) inset',
  textOverflow: 'ellipsis',
  _hover: {
    bg: 'alpha.500',
    boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.50) inset',
  },
  '.chakra-badge': {
    mr: '1',
    mt: '1.5',
  },
};

export const RaceNumber: CSSObject = {
  color: 'white',
};
export const FlexDetails: CSSObject = {
  color: 'white',
  display: 'block',
  maxW: '16',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const Icon: CSSObject = {
  color: 'white',
};

export const FlexButtonContainer: CSSObject = {
  bg: 'transparent',
  pos: 'relative',
  p: '0',
  pl: '1',
  gap: '1',
};

export const ButtonChevron: CSSObject = {
  boxSize: '7',
  minW: '7',
  color: 'white',
  p: '0',
  borderRadius: 'md',
  bgGradient: 'linear(to-b, alpha.300, alpha.400)',
  boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.20) inset',

  _hover: {
    bg: 'alpha.500',
    boxShadow: '0px 0px 0px 1px rgba(255, 255, 255, 0.50) inset',
  },

  '& > svg': { boxSize: '6' },
};
